export default __webpack_public_path__ + "static/media/1.717ab953.JPG";